module.exports = __webpack_public_path__ + "img/marketing-gift-card.6529a1f5.png";